new Vue({
  el: '#app',

  owCSS: `.ios-smooth-scroll{-webkit-overflow-scrolling:touch}.credit-app{--black:#000;--primary-color:#61b72f;--secondary-color:#54a624;--back-color:#f5f5f5;--front-color:#fff;--label-color:#9e9e9e;--text-dark:#242424;--text-light:#707070;--text-red:#d44c59;--text-blue:#1665c0;--color-gold:#ce9137;--shadow-color:rgba(0,0,0,.24);--line-color:rgba(0,0,0,.12);color:var(--text-dark);display:block;background:#fff;position:fixed;top:0;bottom:0;left:0;width:100%;overflow-x:hidden;--mobile-cont:{max-width:550px;margin:0;display:block;left:0}@apply (--mobile-cont)}.credit-app.black-bg{background:#000!important}@media screen and (min-width:440px){body{background:#f3f4f5}.credit-app{width:440px;min-height:456px;max-height:560px;border-radius:8px;box-shadow:0 2px 4px 0 rgba(0,0,0,.24);right:0;margin:auto}}.view{height:100%}.cc-sheet .ow-button-wrapper{display:flex}.cc-sheet.sheet-mask.fixed-true{position:fixed!important}.cc-sheet.sheet-mask .sheet-container{position:relative;padding:24px 0 16px!important;box-sizing:border-box}.cc-sheet.sheet-mask .sheet-header{display:none}.cc-sheet.sheet-mask .sheet-image{float:right}.cc-sheet.sheet-mask .info-content{color:#242424;font-size:16px;font-weight:400;letter-spacing:.15px;line-height:24px;opacity:1}.cc-sheet.sheet-mask .ow-button-container{height:auto!important;margin:16px 16px 0}.cc-sheet.sheet-mask .ow-button-container.cta-button{margin:16px 0 0}.cc-sheet.sheet-mask .ow-button--mask{margin-bottom:0}#reviewDetailsPage .ow-button-container{margin-top:0!important}.hide{display:none}.cc-back-btn-wrapper{width:40px;height:40px;position:fixed;border-radius:50%;top:8px;left:8px;z-index:999}.cc-back-btn-wrapper.custom-type1,.cc-back-btn-wrapper.custom-type2{color:#fff}.cc-back-btn-wrapper.add-shadow{box-shadow:0 4px 8px 0 rgba(0,0,0,.1);background-color:#fff;color:#000}.cc-back-btn-wrapper.custom-type1.add-shadow{background-color:#141420;color:#fff;box-shadow:0 0 17px -4px #fff}.cc-back-btn-wrapper i svg{top:8px}.upper-container{box-sizing:border-box;box-shadow:0 6px 10px 0 transparent;padding:0 0 16px}.upper-container .heading,.upper-container .text{color:#242424}.upper-container .heading{padding:0 0 8px;font-size:24px;font-weight:500;letter-spacing:0;line-height:32px;max-width:66%}.lower-container{margin:auto;overflow:auto;position:relative}.upper-container .text{padding:8px 0 32px;font-size:14px;letter-spacing:.13px;line-height:20px;margin:0;max-width:66%}.position-right{position:absolute;top:0;right:0}.button_footer{position:fixed;bottom:0;left:0;width:100%;background:#fff;box-shadow:0 4px 26px 8px #fff}input:-webkit-autofill,input:-webkit-autofill:active,input:-webkit-autofill:focus,input:-webkit-autofill:hover{box-shadow:inset 0 0 0 30px #fff!important}button{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.tncLink{color:#4482cc;font-weight:500;text-decoration:underline}.info-container{padding:24px 0;color:#707070;border-top:1px solid rgba(0,0,0,.12);border-bottom:1px solid rgba(0,0,0,.12)}.note-content{color:#242424;font-weight:500;padding:0 40px 0 16px;border-left:2px solid #e98422}.info-bullet,.note-content{font-size:14px;letter-spacing:0;line-height:20px}.info-bullet{color:#707070;font-weight:400;padding:12px 40px 0 16px;position:relative}.info-bullet:before{content:"•";position:absolute;left:0;top:26%}.disclaimer-text{color:#707070;padding:24px 16px 24px 0}.disclaimer-text,.instructions-wrapper{font-size:12px;font-weight:400;letter-spacing:0;line-height:16px}.instructions-wrapper{color:#242424;padding:0 16px 10px 0}.section-heading{color:#242424;font-size:16px;font-weight:500;height:24px;letter-spacing:0;line-height:24px;padding-top:24px}#cardTermsSheet .instructions-wrapper{color:#707070;padding:0}#cardTermsSheet .disclaimer-text{margin:0 0 16px;padding:0;color:#242424;font-weight:400;font-size:14px;line-height:20px}.bottom-80{position:absolute;bottom:80px}.bottom-64{position:absolute;bottom:64px}.fade-enter-active,.fade-leave-active{transition:opacity .5s}.fade-enter,.fade-leave-to{opacity:0}.text-container{color:rgba(36,36,36,.56);font-family:Roboto-Regular;font-size:14px;line-height:20px;margin-bottom:16px}.text-container p{margin:0;margin-bottom:16px}.text-container ul{margin:0;padding-left:16px}.text-container li{margin-bottom:16px}#termsAndConditionPopup{color:rgba(36,36,36,.56);font-family:Roboto-Regular;font-size:14px;line-height:20px;margin-bottom:16px}#termsAndConditionPopup p{margin:0;margin-bottom:16px}#termsAndConditionPopup ul{margin:0;padding-left:16px}#termsAndConditionPopup li{margin-bottom:16px}`,
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      class: _vm.isMobile && _vm.addCSS && (("credit-app " + (_vm.mobileOS === 'ios' ? 'ios' : 'non-ios'))),
      attrs: {
        "id": "credit-app"
      }
    }, [_c('transition', {
      attrs: {
        "name": "slide-fade",
        "mode": "out-in"
      }
    }, [
      [_c('keep-alive', {
        attrs: {
          "include": ['transaction-otp']
        }
      }, [_c('router-view', {
        staticClass: "view"
      })], 1)]
    ], 2), _vm._v(" "), (_vm.owRegistry['sheet'] && _vm.showSheet) ? _c('sheet', {
      attrs: {
        "handleContentClick": false,
        "bgClickClose": true,
        "classProp": ("cc-sheet fixed-" + (!!_vm.sheetDataObj.isFixed)),
        "idProp": _vm.sheetDataObj.idProp,
        "isDesktop": _vm.sheetDataObj.isDesktop || false,
        "context": _vm.sheetDataObj.context,
        "eventName": _vm.sheetDataObj.eventName,
        "eventPage": _vm.sheetDataObj.eventPage,
        "eventPayload": _vm.sheetDataObj.eventPayload
      },
      on: {
        "close": function($event) {
          return _vm.handleSheetClose(_vm.sheetDataObj)
        }
      }
    }, [_c('div', {
      attrs: {
        "slot": "body"
      },
      slot: "body"
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.sheetDataObj.imgSrc),
        expression: "sheetDataObj.imgSrc"
      }],
      staticClass: "sheet-image"
    }, [_c('img', {
      attrs: {
        "src": ("" + (_vm.sheetDataObj.imgSrc)),
        "alt": "sheet-img"
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.sheetDataObj.heading),
        expression: "sheetDataObj.heading"
      }],
      class: ("main-content " + (_vm.sheetDataObj.imgSrc ? '' : 'fullwidth') + " " + (_vm.sheetDataObj.subheading ? 'nobottom' : ''))
    }, [_vm._v("\n        " + _vm._s(_vm.sheetDataObj.heading) + "\n      ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.sheetDataObj.subheading),
        expression: "sheetDataObj.subheading"
      }],
      class: ("subheader  " + (_vm.sheetDataObj.imgSrc ? '' : 'fullwidth'))
    }, [_vm._v("\n        " + _vm._s(_vm.sheetDataObj.subheading) + "\n      ")]), _vm._v(" "), (_vm.sheetDataObj.isHtml) ? [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.sheetDataObj.htmlContent)
      }
    })] : [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.sheetDataObj.infoContent),
        expression: "sheetDataObj.infoContent"
      }],
      staticClass: "info-content",
      domProps: {
        "innerHTML": _vm._s(_vm.sheetDataObj.infoContent)
      }
    })], _vm._v(" "), (_vm.sheetDataObj.dynamicComponent) ? [_c(_vm.sheetDataObj.dynamicComponent.name, _vm._b({
      tag: "component",
      attrs: {
        "context": _vm.sheetDataObj.context
      }
    }, 'component', _vm.sheetDataObj.dynamicComponent.props, false))] : _vm._e()], 2), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [(!_vm.sheetDataObj.doubleCTA) ? [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.sheetDataObj.buttonText),
        expression: "sheetDataObj.buttonText"
      }],
      staticClass: "footer"
    }, [(_vm.owRegistry['ow-button']) ? _c('ow-button', {
      attrs: {
        "width": "100%",
        "height": "48px",
        "type": "green"
      },
      on: {
        "click": function($event) {
          return _vm.handleSheetClose(_vm.sheetDataObj)
        }
      }
    }, [_vm._v(_vm._s(_vm.sheetDataObj.buttonText))]) : _vm._e()], 1)] : [_c('div', {
      staticClass: "footer"
    }, [_c('div', {
      staticClass: "ow-button-wrapper"
    }, [(_vm.owRegistry['ow-button']) ? _c('ow-button', {
      attrs: {
        "width": "100%",
        "maxWidth": "calc(50% - 6px)",
        "height": "48px",
        "type": "mask",
        "buttonWrapperStyles": {
          marginRight: '12px',
          flexBasis: '0px',
          flexGrow: 1
        }
      },
      on: {
        "click": function($event) {
          typeof _vm.sheetDataObj.leftCtaHandler === 'function' ?
            _vm.sheetDataObj.leftCtaHandler() :
            _vm.handleSheetClose(_vm.sheetDataObj)
        }
      }
    }, [_vm._v(_vm._s(_vm.sheetDataObj.leftCtaText))]) : _vm._e(), _vm._v(" "), (_vm.owRegistry['ow-button']) ? _c('ow-button', {
      attrs: {
        "maxWidth": "calc(50% - 6px)",
        "width": "100%",
        "height": "48px",
        "type": "green",
        "buttonWrapperStyles": {
          marginLeft: '0px',
          flexBasis: '0px',
          flexGrow: 1
        }
      },
      on: {
        "click": function($event) {
          typeof _vm.sheetDataObj.rightCtaHandler === 'function' ?
            _vm.sheetDataObj.rightCtaHandler() :
            _vm.handleSheetClose(_vm.sheetDataObj)
        }
      }
    }, [_vm._v(_vm._s(_vm.sheetDataObj.rightCtaText))]) : _vm._e()], 1)])]], 2)]) : _vm._e(), _vm._v(" "), (_vm.owRegistry['pilot-styles']) ? _c('pilot-styles') : _vm._e()], 1)
  },
  staticRenderFns: [],

  name: "app",
  router: router,
  store: store,
  data: function data() {
    return {
      tag: "Application",
      heading: "Ola Money",
      cancelled: false,
      mobileOS: this.getMobileOperatingSystem(),
      isMobile: true,
      addCSS: true
    };
  },

  computed: {
    showSheet: function showSheet() {
      return this.$store.getters.getSheetStateFromStore;
    },
    sheetDataObj: function sheetDataObj() {
      return this.$store.getters.getSheetDataObjFromStore;
    }
  },
  created: function created() {
    var _this = this;

    if (window.location.pathname === "/credit-app/insurance/") {
      this.addCSS = false;
      this.isMobile = util.isMobile();
    }
    window.setAuthToken = function(token) {
      _this.$store.commit("SET_CREDENTIALS", {
        accessToken: token || ""
      });
      _this.$store.commit("SET_IS_TOKEN_REFRESHED", true);
      _this.$store.dispatch("handleSplit");
    };

    var accessToken = this.getCookie("SESSION_KEY");
    if (!accessToken) {
      if (typeof JSInterface !== "undefined") {
        JSInterface.refreshToken && JSInterface.refreshToken();
      } else {}
    } else {
      var obj = {
        accessToken: accessToken
      };
      this.$store.commit("SET_CREDENTIALS", obj);
      this.deleteCookie("SESSION_KEY");
      this.$store.dispatch("handleSplit");
    }
    this.setUrlParams(true);
  },
  mounted: function mounted() {
    var _this2 = this;

    window.bus = new Vue();

    window.onclick = function(e) {
      if (e.target.dataset.urltype === "openInBrowser") {
        var urlToBeSent = e.target.dataset.url;
        if (typeof JSInterface !== "undefined") {
          if (_this2.mobileOS === "ios") {
            JSInterface.handleExternalUrl(JSON.stringify({
              urlType: "openInBrowser",
              url: urlToBeSent
            }));
          } else if (_this2.mobileOS === "android") {
            JSInterface.handleExternalUrl(urlToBeSent);
          } else {
            console.warn("MOBILE OS not supported!");
          }
        }
      }
    };

    window.onpopstate = function(e) {
      _this2.handleSheetClose(_this2.sheetDataObj);
    };

    document.getElementById("credit-app").addEventListener("scroll", this.handleScroll);

    String.prototype.capitalise = function() {
      return this.split(" ").map(function(a) {
        return a && a[0].toUpperCase() + a.toLowerCase().substr(1);
      }).join(" ");
    };

    var self = this;

    var path = window.location.pathname;
    this.log(this.tag, "Entry path is : " + path);

    this.loadOWComponent("progress-tracker", "components/progress-tracker.js");
    this.loadOWComponent("ow-loader", "ow-components/ow-loader.js");
    this.loadOWComponent("page-header", "components/page-header.js");
    this.loadOWComponent("nps", "components/nps.js");
    if (path.indexOf("login") > -1 || path === "/") {
      this.loadOWComponent("login-page", "pages/login-page.js");
      this.setInstrumentationCookies();
    } else if (path.indexOf("postpaid") > -1) {
      this.loadOWComponent("postpaid-debit", "pages/postpaid-debit.js");
      this.setInstrumentationCookies();
    } else if (path.indexOf("ola-foundation-donation") > -1) {
      this.loadOWComponent("ola-foundation-donation", "pages/ola-foundation-donation.js");
      this.setInstrumentationCookies();
    } else if (path.indexOf("acceptcredit") > -1) {
      this.loadOWComponent("credit-accept", "pages/credit-accept.js");
      this.loadOWComponent("sms-tnc-page", "pages/sms-tnc-page.js");
      this.loadOWComponent("min-kyc-otp", "pages/min-kyc-otp.js");
      this.loadOWComponent("user-details", "pages/user-details.js");
      this.loadOWComponent("status-page", "pages/status-page.js");
      if (this.mobileOS === "android") {
        this.loadOWComponent("update-app", "pages/update-app.js");
      }
      this.setInstrumentationCookies();
    } else if (path.indexOf("transaction-otp") > -1) {
      this.loadOWComponent("transaction-otp", "pages/payment/transaction-otp.js");
      this.loadOWComponent("ow-info-toast", "ow-components/ow-info-toast.js");
    } else if (path.indexOf("raise-concern") > -1) {
      this.loadOWComponent("raise-concern", "pages/common/raise-concern.js");
    } else if (path.indexOf("payment-status") > -1) {
      this.loadOWComponent("payment-status", "pages/payment-status.js");
    } else if (path.indexOf("insurance-status") > -1) {
      this.loadOWComponent("insurance-status", "insurance/insurance-status.js");
    } else if (path.indexOf("insurance") > -1) {
      this.setInstrumentationCookies();
      this.loadOWComponent("insurance-page", "insurance/insurance-page.js");
    } else if (path.indexOf("info") > -1) {
      this.loadOWComponent("info-page", "pages/info-page.js");
    } else if (path.indexOf("cc-onboard") > -1) {
      this.loadOWComponent("cc-onboard", "pages/cc-onboard/cc-onboard.js");
    } else if (path.indexOf("cc-account-breakup") > -1) {
      this.loadOWComponent("cc-account-breakup", "pages/cc-account/cc-account-breakup.js");
    } else if (path.indexOf("cc-account") > -1) {
      this.loadOWComponent("cc-account", "pages/cc-account/cc-account.js");
      this.loadOWComponent("cc-empty-state", "pages/cc-account/cc-empty-state.js");
    } else if (path.indexOf("cc-nps") > -1) {
      this.loadOWComponent("cc-nps", "pages/cc-account/cc-nps.js");
    } else if (path.indexOf("rsa") > -1) {
      this.loadOWComponent("rsa-home", "pages/rsa/rsa-home.js");
    } else if (path.indexOf("cc-transaction-history") > -1) {
      this.loadOWComponent("cc-transaction-history", "pages/cc-account/cc-transaction-history.js");
    } else if (path.indexOf("cc-track-status") > -1) {
      this.loadOWComponent("cc-track-status", "pages/cc-track-status.js");
    } else if (path.indexOf("cc-offer-dynamic") > -1) {
      this.loadOWComponent("cc-offer-dynamic", "pages/cc-offer-dynamic.js");
    } else if (path.indexOf("cc-offer-page") > -1) {
      this.loadOWComponent("cc-offer-page", "pages/cc-offer-page.js");
    } else if (path.indexOf("cc-csq") > -1) {
      this.loadOWComponent("cc-csq", "pages/cc-csq/cc-csq.js");
    } else if (path.indexOf("cc-offers-list-page") > -1) {
      this.loadOWComponent("cc-offers-list-page", "pages/cc-account/cc-offers-list-page.js");
    } else if (path.indexOf("cc-express-interest-landing") > -1) {
      this.loadOWComponent("cc-express-interest-pitch", "pages/cc-onboard/cc-express-interest-pitch.js");
      this.loadOWComponent("cc-express-interest", "pages/cc-onboard/cc-express-interest.js");
    } else if (path.indexOf("credit-card") > -1) {
      var _ref = window || {},
        _ref$owConfig = _ref.owConfig;

      _ref$owConfig = _ref$owConfig === undefined ? {} : _ref$owConfig;
      var _ref$owConfig$creditC = _ref$owConfig.creditCard;
      _ref$owConfig$creditC = _ref$owConfig$creditC === undefined ? {} : _ref$owConfig$creditC;
      var initOnboardResponse = _ref$owConfig$creditC.initOnboardResponse,
        redirectRoute = _ref$owConfig$creditC.ccInitRoute,
        _ref$owConfig$ccABTes = _ref$owConfig.ccABTest;
      _ref$owConfig$ccABTes = _ref$owConfig$ccABTes === undefined ? {} : _ref$owConfig$ccABTes;
      var availableVersions = _ref$owConfig$ccABTes.availableVersions;


      if (redirectRoute === "/cc-express-interest-landing") {
        this.loadOWComponent("cc-express-interest-pitch", "pages/cc-onboard/cc-express-interest-pitch.js", function() {
          _this2.$router.replace(redirectRoute);
        });
      } else {
        if (initOnboardResponse) {
          var _ref2 = JSON.parse(initOnboardResponse) || {},
            abPitchSegment = _ref2.abPitchSegment,
            _ref2$ccUserApplicati = _ref2.ccUserApplicationData;

          _ref2$ccUserApplicati = _ref2$ccUserApplicati === undefined ? {} : _ref2$ccUserApplicati;
          var ccOnboardPageNo = _ref2$ccUserApplicati.pageNo;

          if (availableVersions.indexOf(abPitchSegment) > -1) {
            this.$store.commit("SET_CC_PITCHPAGE_VARIANT", abPitchSegment);
          }

          this.navigateToActiveScreen(+ccOnboardPageNo);
        }
      }
    } else if (path.indexOf("cc-billdesk-payment-init") > -1) {
      this.loadOWComponent("cc-billdesk-payment-init", "pages/cc-account/cc-billdesk-payment-init.js");
    }

    this.loadOWComponent("header-with-logo", "components/header-with-logo.js");
    this.loadOWComponent("shimmer", "components/shimmer.js");
    this.loadOWComponent("pilot-styles", "components/pilot-styles.js");
    this.loadOWComponent("sheet", "components/sheet.js");
    Vue.nextTick(function() {
      self.loadOWComponent("loading-button", "components/loading-button.js");
      self.loadOWComponent("credit-header", "components/credit-header.js");
      self.loadOWComponent("error-sheet", "components/error-sheet.js");
      self.loadOWComponent("payment-page", "pages/payment-page.js");
      self.loadOWComponent("ow-button", "ow-components/ow-button.js");
      self.loadOWComponent("ow-icon", "ow-components/ow-icon.js");
    });
  },

  methods: {
    setInstrumentationCookies: function setInstrumentationCookies() {
      this.log(this.tag, "setInstrumentationCookies");
      var installId = this.getCookieOrSet("install_id");
      this.log(this.tag, "Install Id is: " + installId);

      var transactionId = this.guid();
      this.setCookie("transaction_id", transactionId);
      this.log(this.tag, "Transaction Id is: " + transactionId);
    },
    initStringFormatter: function initStringFormatter() {
      if (!String.prototype.format) {
        String.prototype.format = function() {
          var args = arguments;
          return this.replace(/{(\d+)}/g, function(match, number) {
            return typeof args[number] !== "undefined" ? args[number] : match;
          });
        };
      }
    },
    handleScroll: function handleScroll(e) {
      var scrollTopEle = e.target.scrollTop,
        backBtnEle = document.getElementById("ccBackBtnWrapper");

      if (scrollTopEle > 28) {
        backBtnEle && backBtnEle.classList.add("add-shadow");
      } else {
        backBtnEle && backBtnEle.classList.remove("add-shadow");
      }
    },
    navigateToActiveScreen: function navigateToActiveScreen(pageNo) {
      var _this3 = this;

      var redirectRoute = "/cc-onboard/onboarding";
      if (Boolean(pageNo)) {
        switch (pageNo) {
          case 1:
            redirectRoute = "/cc-onboard/1";
            break;
          case 2:
            redirectRoute = "/cc-onboard/2";
            break;
          case 3:
            redirectRoute = "/cc-onboard/3";
            break;
          case 4:
            redirectRoute = "/cc-onboard/4.1";
            break;
          case 5:
            redirectRoute = "/cc-onboard/4.2";
            break;
          case 6:
            redirectRoute = "/cc-onboard/5";
            break;
          default:
            redirectRoute = "/cc-onboard/onboarding";
        }
      }

      this.loadOWComponent("cc-onboard", "pages/cc-onboard/cc-onboard.js", function() {
        _this3.$router.replace(redirectRoute);
      });
    }
  }

});